/**
 * Created by sivanh on 12/06/2018.
 */
define(function (require) {
    "use strict";
    var LE = require("app");

    var ScheduleEventItemView = require("manager-views/schedule/ScheduleEventItemView");
    var template = require("manager-templates/schedule/scheduleEventsListView.tmpl");

    var ScheduleEventsListView = {};
    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ScheduleEventsListView = Marionette.CompositeView.extend({
            itemViewContainer: '.schedule-events-container',
            template: template,
            itemView: ScheduleEventItemView,
            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function() {
                this._onRender();
            },

            _initialize: function(options) {
                this.channel = options.channel;
                this.container = options.container;
                this.itemViewOptions = {channel: options.channel};
            },

            _onRender: function() {
                if (this.container) {
                    this.container.append(this.$el);
                }
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return ScheduleEventsListView;
});

